import * as Actions from 'app/store/actions';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

function useReduxMessage(message = {}) {
  const dispatch = useDispatch();

  const ref = useRef(message);

  useEffect(() => {
    ref.current = message;
    if (message && message.message) {
      dispatch(
        Actions.showMessage({
          message: message.message,
          variant: message.variant,
        })
      );
    }
  }, [message, dispatch]);

  const dispatchHideMessage = () => dispatch(Actions.hideMessage());

  return [ref.current, dispatchHideMessage];
}

export default useReduxMessage;
